export const convertCurrencyFormat = (price: number, format = "ARS") =>
  new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: format,
  }).format(price);
